import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import Navbar from '../../components/Navbar';

// Proponent shell — authenticated user with globalRole='proponent'.
// Proponents are agents (government, NGO, etc.) with cross-community visibility
// based on their active memberships per tenant.
const NAV = [
  { to: '/dashboard',  label: 'Dashboard' },
  { to: '/proponent',  label: 'My Communities' },
  { to: '/membership', label: 'Join a Community' },
];

const ProponentShell = () => (
  <div className="shell shell--proponent">
    <Navbar />
    <div className="shell-body">
      <nav className="shell-sidenav" aria-label="Proponent navigation">
        <span className="shell-sidenav__heading">Proponent Portal</span>
        <ul>
          {NAV.map(({ to, label }) => (
            <li key={to}>
              <NavLink
                to={to}
                className={({ isActive }) =>
                  isActive ? 'shell-sidenav__link shell-sidenav__link--active' : 'shell-sidenav__link'
                }
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <main className="shell-content">
        <Outlet />
      </main>
    </div>
  </div>
);

export default ProponentShell;
